export { MainsIcon } from './mains-icon';
